import { Navigate } from 'react-router-dom';
import { useAuth } from '../../modules/auth/context/AuthContext';

const ROLE_HIERARCHY = {
  USER: 0,
  ADMIN: 100,
};

/**
 * @param {string} minRole — минимальная требуемая роль
 *
 * Проверяет доступ:
 * 1. globalRole пользователя >= minRole → доступ есть
 * 2. Если globalRole недостаточна — проверяет direction-роли и org-роли
 */
export default function ProtectedRoute({ minRole, appSlug, children }) {
  const { user, directions, organizationRoles, apps, isLoading } = useAuth();

  if (isLoading) {
    return <div style={{ padding: 40, textAlign: 'center', color: 'var(--spark-color-text-muted)' }}>Завантаження...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  const userLevel = ROLE_HIERARCHY[user.globalRole] ?? 0;
  const minLevel = ROLE_HIERARCHY[minRole] ?? 0;

  // Проверяем globalRole (только ADMIN даёт глобальный доступ)
  if (userLevel >= minLevel) {
    // Если указан appSlug — дополнительно проверяем, что есть хоть одно разрешение для этого приложения
    if (appSlug) {
      const hasAccess = user.globalRole === 'ADMIN' || apps.some((a) => a.slug === appSlug);
      if (!hasAccess) return <Navigate to="/" replace />;
    }
    return children;
  }

  // Если требуется ADMIN, без global ADMIN доступ запрещён
  if (minRole === 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  // Для USER достаточно быть аутентифицированным
  if (minRole === 'USER') {
    return children;
  }

  return <Navigate to="/" replace />;
}
